import axios from './BaseService';

const UPGRADE_REQUESTS_URL = `${
    process.env.REACT_APP_API_URL || window._env_?.REACT_APP_API_URL
}/upgrade-requests/`;

export async function getUpgradeRequests(status) {
    const url = `${UPGRADE_REQUESTS_URL}${status ? `?status=${status}` : ''}`;

    const response = await axios.get(url);
    return response.data;
}

export async function approveUpgradeRequest(id) {
    const response = await axios.post(
        `${UPGRADE_REQUESTS_URL}${id}/approve`,
        {},
    );
    return response.data; //{id, status, paymentLink, emailSent}
}

export async function rejectUpgradeRequest(id) {
    const response = await axios.post(
        `${UPGRADE_REQUESTS_URL}${id}/reject`,
        {},
    );
    return response.data;
}

export async function activateUpgradeRequest(id) {
    const response = await axios.post(
        `${UPGRADE_REQUESTS_URL}${id}/activate`,
        {},
    );
    return response.data;
}
